import React from "react";

interface HoverExpandButtonProps extends React.ComponentProps<"button"> {
  /** Label text revealed on hover */
  label: string;
  /** Base background and text colors */
  colorClass?: string; // e.g. "bg-blue-600 text-white"
  hoverWidth?: string;
}

/**
 * A compact button that expands horizontally on hover to reveal a label.
 *
 * Usage:
 * <HoverExpandButton label="Create Order">
 *   <PlusIcon className="w-5 h-5" />
 * </HoverExpandButton>
 */
export default function HoverExpandButton({
  label,
  colorClass = "bg-custom-blue-medium text-white",
  hoverWidth = "hover:w-36",
  className = "",
  children,
  ...props
}: HoverExpandButtonProps) {
  return (
    <button
      {...props}
      className={`
        group relative flex items-center justify-center
        w-10 h-8 rounded-xl
        ${colorClass} font-medium
        transition-all duration-300 ease-in-out overflow-hidden
        ${hoverWidth} hover:rounded-xl
        ${className}
      `}
    >
      {/* Always visible icon or content */}
      <span className="flex-none">{children}</span>

      {/* Label text appears on hover */}
      <span
        className="
          hidden group-hover:inline-block
          ml-2 whitespace-nowrap text-sm
          transition-opacity duration-200 ease-in-out
        "
      >
        {label}
      </span>
    </button>
  );
}
